import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { OAuthUrlResponse, CrmProviderType } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export type GetOAuthUrlParams = {
  organizationId: string;
  provider: CrmProviderType;
  targetUrl: string;
};

export const getOAuthUrl = async (
  params: GetOAuthUrlParams
): Promise<OAuthUrlResponse> => {
  return await tinctApi.crmIntegrations.getOAuthUrl(params);
};

export const useGetOAuthUrl = (
  options?: Omit<
    UseMutationOptions<OAuthUrlResponse, ApiError, GetOAuthUrlParams>,
    'mutationFn'
  >
) =>
  useMutation({
    mutationFn: getOAuthUrl,
    ...options,
  });
